import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
const historyAnalysis = {
	data() {
		return {
			analysisAvgInfo: [],
			analysisDetailInfo: [],
			analysis: []
		}
	},
	mounted() {
		this.getAnalysisAvg()
	},
	methods: {
		getAnalysisAvg() {
			this.$post('/reportApi/queryExamSubjectAvgCompare', this.params).then(res => {
				let echarts = []
				let axis = new Set()
				res.data[0].examInfoDTOList.forEach(xItem => {
					xItem.sqaList.forEach(lis => {
						axis.add(lis.className)
					})
				})
				let xAxis = Array.from(axis).sort((a, b) => Number(a.split('班')[0]) - Number(b.split('班')[0]))
				res.data.forEach(resp => {
					let unitSeries = []
					resp.examInfoDTOList.forEach(element => {
						let miniData = new Array(xAxis.length).fill(null)
						element.sqaList.forEach(ele => {
							if (xAxis.includes(ele.className)) {
								let index = xAxis.indexOf(ele.className)
								miniData[index] = ele.avgScore
							}
						})
						unitSeries.push({
							data: miniData,
							type: 'line',
							smooth: true,
							symbol: 'circle',
							symbolSize: 10
						})
					})
					let lineOptions = {
						grid: {
							top: '15',
							left: '50',
							right: '10',
							bottom: '30'
						},
						xAxis: {
							type: 'category',
							data: xAxis,
							axisTick: false,
							axisLine: {
								lineStyle: {
									color: '#a3a5a5'
								}
							}
						},
						yAxis: {
							type: 'value',
							axisTick: false,
							axisLine: {
								show: false
							},
							splitLine: {
								lineStyle: {
									type: 'dotted'
								}
							}
						},
						tooltip: {
							show: true,
							trigger: 'item',
							formatter: data => {
								return `${data.data}`
							}
						},
						series: unitSeries
					}
					echarts.push(lineOptions)
				})
				this.getAnalysisDetails(echarts)
			})
		},
		getAnalysisDetails(echarts) {
			this.$post('/reportApi/queryExamSubjectDetailsCompare', this.params).then(res => {
				res.data.forEach((res, index)=>{
					this.analysis.push({
						echarts:echarts[index],
						tableData:res
					})
				})
			})
		}
	}
}

export default historyAnalysis
